import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { withRouter } from "react-router"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import Button from '@material-ui/core/Button';

import Loading from 'components/Loading'
import EmptyStorage from 'components/common/EmptyStorage'
import Footer from 'components/common/Footer'
import Block from 'components/common/Block'
import TablePaginationActions from '../common/TablePaginationActions'
import NoDataRow from '../common/NoDataRow'

import { getInboundOrderList } from '../../actions/asyncOrders'

import { formatDate, PAGE_SIZE } from 'libraries/utils'

class InboundList extends Component {
	constructor() {
		super()
		this.state = {
			page: 0,
		}
	}

	componentDidMount() {
		// api param page start from 1
		this.props.getInboundOrderList(this.state.page + 1, PAGE_SIZE)
	}

	handleChangePage = (newPage) => {
		this.setState({ page: newPage }, () => {
			this.getInboundOrderList(this.state.page + 1, PAGE_SIZE) // page, perPage
		})
	}

	onClickPay = event => {
		const orderId = event.currentTarget.dataset.orderid
		this.props.history.push('/member/inbound/detail', orderId)
	}

	goToReservation = () => {
		this.props.history.push('/how-to-use', 2)
	}

	render() {
		const { t, isLoading, inboundOrderList } = this.props
		const { page } = this.state


		if (isLoading) {
			return (<Loading isLoading={this.props.isLoading} />)
		}

		if (inboundOrderList.get('list').size === 0) {
			return (
				<EmptyStorage type="inbound-list" onClick={this.goToReservation}/>
			)
		}

		return (
			<Grid container justify="center" className="order-list">
				<Grid item md={8}>
					<Grid container alignItems="baseline" style={{ marginBottom: '15px' }}>
						<Typography variant="h1">{t('inbound_list')}</Typography>
					</Grid>

					<Footer />

					<Block title={t('inbound_subtitle')}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell style={{ paddingLeft: '30px' }}>{t('create_date')}</TableCell>
									<TableCell>{t('bottle_number')}</TableCell>
									<TableCell>{t('inbound_detail_title')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{inboundOrderList.get('list').map(item => {
									const createDate = formatDate(item.get('createdAt'))
									return (
										<TableRow hover key={item.get('id')}>
											<TableCell style={{ paddingLeft: '30px' }}>{createDate}</TableCell>
											<TableCell>{item.get('totalBottle')}</TableCell>
											<TableCell>
												<Button color="primary" variant="contained"
													data-orderid={item.get('id')}
													onClick={this.onClickPay}
												>
													{'明細確認'}
												</Button>
											</TableCell>
										</TableRow>
									)
								})}
								{!inboundOrderList.size &&
									<NoDataRow colSpan={3} />
								}
							</TableBody>
							{inboundOrderList.size &&
								<TableFooter>
									<TableRow>
										<TablePagination
											className="pagination"
											rowsPerPageOptions={[]}
											labelDisplayedRows={() => null}
											count={inboundOrderList.getIn(['pagination', 'totalCount'])}
											rowsPerPage={PAGE_SIZE}
											page={page}
											onChangePage={this.handleChangePage}
											ActionsComponent={TablePaginationActions}
										/>
									</TableRow>
								</TableFooter>
							}
						</Table>
					</Block>
				</Grid>
			</Grid>
		)
	}
}

const mapStateToProps = state => ({
	inboundOrderList: state.orders.inboundOrderList,
})

const mapDispatchToProps = {
	getInboundOrderList
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withTranslation()(InboundList)))